<template>
  <section class="bodypad">
    <v-row class="mt-4">
      <div class="left-col">
        <header class="d-flex justify-space-between mb-8">
          <h1 class="text-h6 text-md-h5 font-weight-bold">Facturación</h1>
          <v-btn text color="blue darken-2"
            ><v-icon>file_download</v-icon>descargar en pdf</v-btn
          >
        </header>
        <main class="d-flex flex-column" style="gap: 1.5rem">
          <BillAlert />

          <section class="d-flex flex-column">
            <BillCard v-for="bill of bills" :key="bill.id" :bill="bill" />
            <v-btn
              v-if="bills?.length > 5"
              style="align-self: center"
              class="mt-6"
              text
              color="blue darken-2"
              @click="toggleVisible"
            >
              {{ showAll ? "Ver menos" : "Ver más" }}
            </v-btn>
          </section>
        </main>
      </div>
    </v-row>
  </section>
</template>

<script>
import BillCard from "../components/BillCard.vue";
import BillAlert from "../components/BillAlert.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "BillView",
  components: { BillCard, BillAlert },
  data: () => ({
    showAll: false,
    maxVisible: 5,
  }),
  computed: {
    ...mapState("invoice", {
      bills: (state) => state.invoices,
    }),
    
    visibleBills() {
      return this.showAll ? this.bills : this.bills.slice(0, this.maxVisible);
    },
  },
  created() {
    this.getBills();
  },
  methods: {
    ...mapActions("invoice", ["getBills"]),

    toggleVisible() {
      this.showAll = !this.showAll;
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .left-col {
    width: 100%;
  }
}

@media (min-width: 960px) {
  .left-col {
    width: 65%;
  }
}

.bodypad {
  padding: 12px 24px 108px 24px;
}
</style>
